import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup  } from '@angular/forms';
import { UserToGroupService, UserToGroupRelation } from '@schoolbelle/api/user-to-group';

@Component({
  selector: 'app-group-info',
  templateUrl: './group-info.component.html',
  styleUrls: ['./group-info.component.scss']
})
export class GroupInfoComponent implements OnInit {
  @Input('form') form:FormGroup;
  @Input() showPurchaseType:boolean = false;
  accountId:FormControl;
  toExistingGroup:FormControl;
  purchaseType:FormControl;

  groupType:FormControl;
  groupName:FormControl;
  groupAddress:FormControl;
  group_types = ['school.kindergarten', 'school.elementary', 'school.middle', 'school.high', 'school.combined']; //  첫 구매시에는 학교형태를 입력한다.

  constructor(
    public utg:UserToGroupService,
  ) { 

    
  }

  adminSchools:UserToGroupRelation[] = [];
  ngOnInit() {
    
    this.adminSchools = this.utg.schools.filter(school=>school.admin === true);
    

    this.toExistingGroup = this.form.get('toExistingGroup') as FormControl;
    this.purchaseType = this.form.get('buyerInfo.purchaseType') as FormControl;
    this.accountId = this.form.get('buyerInfo.accountId') as FormControl;
    this.groupType = this.form.get('buyerInfo.groupType') as FormControl;
    this.groupName= this.form.get('buyerInfo.groupName') as FormControl;
    this.groupAddress= this.form.get('buyerInfo.groupAddress') as FormControl;
  }
}
